<tran-ui-content-wrapper>
    <div class="flex flex-col pb-[40px] pt-[40px]">
        <h1 class="text-[40px] font-bold">{{ 'faq.title' | translate }}</h1>
        <p class="text-lg pt-4">{{ 'faq.intro' | translate }}</p>
    </div>

    @for (section of faqSections; track section.title) {
        <h2 class="text-lg font-semibold">{{ section.title | translate }}</h2>
        <si-accordion [expandFirstPanel]="false" class="pb-12 pt-6">
            @for (faq of section.items; track faq.question) {
                <si-collapsible-panel [heading]="faq.question | translate" contentCssClasses="p-6">
                    <div
                        class="faq-html [&_ul]:list-disc [&_ul]:pl-8 [&_ol]:list-decimal [&_ol]:pl-8 [&_a]:text-interactive-coral [&_a]:underline hover:[&_a]:opacity-80"
                        [innerHTML]="faq.answer | translate"
                    ></div>
                </si-collapsible-panel>
            }
        </si-accordion>
    }
    <div class="mt-20"></div>
</tran-ui-content-wrapper>
